var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOrgSearch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32.142,
    height: 40,
    viewBox: "0 0 32.142 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.04,
    y1: 0.326,
    x2: 0.9,
    y2: 0.602,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#265df5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5dc9f0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(-1814 -770)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M26.518,40.267H12.232V5.982H23.661v8.571a2.865,2.865,0,0,0,2.857,2.857h8.571V21.7h2.857V14.553a1.3,1.3,0,0,0-.429-1l-10-10a1.3,1.3,0,0,0-1-.428H12.232A2.865,2.865,0,0,0,9.375,5.982V40.267a2.865,2.865,0,0,0,2.857,2.857H26.518Zm0-33.714,8,8h-8Z",
    transform: "translate(1804.625 766.876)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "search",
    d: "M12.963,7.922a4.855,4.855,0,0,0-1.48-3.561A4.856,4.856,0,0,0,7.922,2.88,4.852,4.852,0,0,0,4.36,4.36,4.858,4.858,0,0,0,2.88,7.922a4.854,4.854,0,0,0,1.48,3.561,4.852,4.852,0,0,0,3.562,1.48,4.859,4.859,0,0,0,3.561-1.48A4.853,4.853,0,0,0,12.963,7.922Zm5.761,9.362a1.461,1.461,0,0,1-1.44,1.44,1.336,1.336,0,0,1-1.013-.428l-3.859-3.848a7.706,7.706,0,0,1-4.49,1.4,7.782,7.782,0,0,1-3.077-.625A7.756,7.756,0,0,1,.625,11a7.891,7.891,0,0,1,0-6.155A7.756,7.756,0,0,1,4.844.625,7.893,7.893,0,0,1,11,.625a7.756,7.756,0,0,1,4.22,4.22,7.766,7.766,0,0,1,.625,3.077,7.7,7.7,0,0,1-1.4,4.49l3.859,3.859a1.378,1.378,0,0,1,.416,1.013Z",
    transform: "matrix(0.978, 0.208, -0.208, 0.978, 1827.827, 787.792)",
    fill: "url(#linear-gradient)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOrgSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/org_search.2340577d328127184efc3e496e6f4dca.svg";